export enum RoleType {
  PANEL = 'Panel',
  OPERATOR = 'Operator',
  DRIVER = 'Driver',
  CLIENT = 'Client'
}
